import React from 'react';
import VIPPanel from './VIPPanel';

export default function AdminVIPPanel() {
  return (
    <VIPPanel
      serviceName="admin/listing-vip-status"
      readOnly={true}
      basePath="/admin"
    />
  );
}
